export default __webpack_public_path__ + "static/media/LOGO.000401fc.png";